import { useClientConfigCtx } from './hooks/useClientConfigCtx';

export const useLocalisedDate = () => {
	const { config } = useClientConfigCtx();
	const date = {
		symbol: config.locale.symbol,
		options: config.locale.options.date,
	};

	const formatDate = (d: string, ignoreTimeZone = false): string => {
		// create a new options object so that we don't mutate the original options object
		const options = { ...date.options };
		if (ignoreTimeZone) {
			options.timeZone = 'GMT';
		}

		return d && new Intl.DateTimeFormat(date.symbol, options).format(new Date(d));
	};

	const formatDataYearMonth = (y: number, m: number): string => {
		const intl = Intl.DateTimeFormat(date.symbol, date.options || {});

		const dateToFormat = Date.UTC(y, m - 1);
		return intl
			.formatToParts(dateToFormat)
			.slice(0, 4)
			.map((a) => a.value)
			.join('');
	};

	const formatHourAndMinutes = (d: string): string => {
		if (!d) return '';
		const utcDate = new Date(d.endsWith('Z') ? d : d + 'Z');
		const hours = utcDate.getHours().toString().padStart(2, '0');
		const minutes = utcDate.getMinutes().toString().padStart(2, '0');
		return `${hours}:${minutes}`;
	};

	return {
		date,
		formatDate,
		formatDataYearMonth,
		formatHourAndMinutes,
		locale: config.locale,
	};
};
